<template>
  <div
    :id="gramId"
    class="ud-Visit_Gram"
    :class="{
      'ud-Visit_Gram_Omo': isOmo,
      'ud-Visit_Gram_CompanyActivity': isCompany
    }"
  >
    <div class="ud-Visit_GramIcon">
      <div v-if="isCompany" class="ud-Visit_GramIcon_CompanyActivity">
        <Icon :icon="iconMailSend" :size="18" :color="iconColor" />
      </div>
      <div v-else class="ud-Visit_GramIcon_Circle">
        <Icon :icon="iconMail" :size="18" :color="iconColor" />
      </div>
    </div>
    <div class="ud-Visit_GramBody">
      <div class="ud-Visit_GramTime">{{ time }}</div>
      <div :class="actionClass">{{ title }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import GramBase from "@/components/observation/visit/gram/GramBase.vue";
import { Gram } from "@/models/Gram";
import { Icons } from "@/const/Icons";
import Icon from "@/components/Icon.vue";
import { Colors } from "@/const/Colors";

@Component({
  components: { Icon }
})
export default class GramContactMail extends GramBase {
  @Prop({ type: Gram, required: true })
  gram!: Gram;

  @Prop({ type: Boolean, required: true })
  isOmo!: boolean;

  iconMail = Icons.Mail;
  iconMailSend = Icons.MailSend;

  get iconColor(): Colors {
    return this.isCompany ? Colors.Base900 : Colors.Blue900;
  }

  get gramId(): string {
    return this.gram.id;
  }

  get time(): string {
    return this.gram.hasTimeOfDay ? this.gram.timeTx : "";
  }

  get isCompany(): boolean {
    return this.gram.isCompany;
  }

  get title(): string {
    return this.gram.contactMailTitle;
  }

  get actionClass(): string {
    return this.isCompany
      ? "ud-Visit_GramCompanyActivity"
      : "ud-Visit_GramAction";
  }
}
</script>
